<div
	*ngIf="isRenderable && linkType"
	[ngbCollapse]="isCollapsed"
	class="linkItem-wrapper select-text fade {{ linkItemWrapperClass ? linkItemWrapperClass : '' }}"
	[ngClass]="{
		'pe-none': !isActionAllowed(),
		'hoverable cursor-pointer': isActionAllowed(),
		'show': !isHidden && !isCollapsed,
		'hideWithoutCollapse': !isCollapsed && isHidden,
		'disabled': isDisabled
	}"
	(click)="onClickEvent()"
>

	<span class="d-flex align-items-center flex-nowrap">

		<!-- Loader -->
		<i
			*ngIf="requestInProgress"
			class="value spinner-border spinner-border-md d-block select-none"
		></i>

		<!-- Email -->
		<ng-container *ngIf="linkType === linkTypeEnum.EMAIL">
			<a
				*ngIf="!requestInProgress"
				class="email-link"
				[ngClass]="{}"
				[href]="'mailto:' + externalHref"
				target="_blank"
			>
				{{ label ?? labelSpare }}
			</a>
		</ng-container>

		<!-- External -->
		<ng-container *ngIf="linkType === linkTypeEnum.EXTERNAL">
			<a
				#externalLinkAnchor
				*ngIf="!requestInProgress"
				class="fw-medium"
				[ngClass]="{
					'external-link': externalHref
				}"
				[href]="externalHref"
				[rel]="'noopener noreferrer'"
				[target]="'_blank'"
				(click)="onExternalLinkClick($event, externalLinkAnchor)"
			>
				{{ label ?? labelSpare }}
			</a>
		</ng-container>

		<!-- Internal -->
		<ng-container *ngIf="linkType === linkTypeEnum.INTERNAL">
			<!-- Icon -->
			<app-svg
				@fadeInOut
				*ngIf="svgType && !requestInProgress"
				[size]="svgSize"
				[type]="svgType"
				class="icon select-none"
				[ngClass]="{
				'me-2': label
			}"
			></app-svg>

			<!-- Label -->
			<label
				@fadeInOut
				*ngIf="!requestInProgress"
				class="m-0 fw-regular fs-md"
				[ngClass]="{
				'text--decoration-underline': label
			}"
			>
				{{ label ?? labelSpare }}
			</label>
		</ng-container>
	</span>
</div>
